import { maxCityLength, maxCurrentEmploymentLength, maxCustomerCommentLength, maxLanguagesFamily, maxNameLength, maxPhoneNoLength, maxPostCodeLength, maxSpecialCareTextLength, maxSpecificAvailabilityByPhoneLength, maxStreetAndHouseNoLength } from "./globals";

export function validateStreetAndHouseNo(streetAndHouseNo) {
    // console.log("streetAndHouseNo: " + streetAndHouseNo);

    if(streetAndHouseNo.length > maxStreetAndHouseNoLength) {
        return false;
    }

    return containsOnlySpaces(streetAndHouseNo);
}

export function validatePostCode(postCode) {
    // Only numbers
    if(!/^\d+$/.test(postCode)) {
        return false;
    }

    if(postCode.length > maxPostCodeLength) {
        return false;
    }

    return true;
}

export function validateCity(city) {
    if(city.length > maxCityLength) {
        return false;
    }

    return containsOnlySpaces(city);
}

export function validateName(name) {
    if(!containsOnlySpaces(name)) {
        return false;
    }

    if(name.length > maxNameLength) {
        return false;
    }

    return true;
}

export function validateCurrentEmployment(currentEmployment) {
    // console.log("cur empl: " + currentEmployment);
    
    if(currentEmployment.length > maxCurrentEmploymentLength) {
        return false;
    }
    
    return containsOnlySpaces(currentEmployment);
}

export function validatePhoneNumber(number) {
    if(!containsOnlySpaces(number)) {
        return false;
    }

    if(number.length > maxPhoneNoLength) {
        return false;
    }

    if(!/^[\+ ]?\d[\d ]*$/.test(number)) {
        return false;
    }

    if(!number.startsWith("+") && !number.startsWith("0")) {
        return false;
    }

    return true;
}

export function validateCustomerComment(comment) {
    return comment.length <= maxCustomerCommentLength;
}

export function validateSpecialCareText(comment) {
    return comment.length <= maxSpecialCareTextLength;
}

export function validateSpecificAvailabilityByPhone(value) {
    if(value.length > maxSpecificAvailabilityByPhoneLength) {
        return false;
    }

    return true;
}


function containsOnlySpaces(str) {
    return /^(?! *$).+/.test(str);
}

function containsAnyNumber(str) {
    return /\d+/.test(str);
}
